<div class="container">
  <div class="toolbar" [class.readonly]="readonly">
    <app-icon name="clear" (click)="close()" class="ml-10"></app-icon>
    <span class="file-name" *ngIf="currentFile">{{ currentFile.value?.fileData.name }}</span>
    <app-icon name="delete" *ngIf="!readonly" class="mr-10" (click)="removeFile()"></app-icon>
  </div>
  <div
    *ngIf="!url"
  >
<!--    todo swiper-->
<!--    [(index)]="activeIndex"-->
<!--    [swiper]="config"-->
<!--    class="swiper-container"-->
<!--    (indexChange)="onIndexChange($event)"-->
    <div class="swiper-wrapper">
      <div class="swiper-slide flex flex-col" *ngFor="let file of files">
        <div class="media-container">
          <div class="pdf" *ngIf="'pdf' === file?.extension; else img">
              <ngx-extended-pdf-viewer [src]="file?.url"
                                       [language]="'pl'"
                                       useBrowserLocale="true"
                                       [zoom]="'page-width'"
                                       height="86vh"></ngx-extended-pdf-viewer>
          </div>

          <ng-template #img>
            <div class="swiper-zoom-container">
              <img [ngSrc]="file.urlSafe" alt="uploaded_file" class="img" />
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <div class="pagination" fxLayout="row">
      <div *ngFor="let index of indexTab" [class.active]="index === activeIndex" class="bullet"></div>
    </div>

    <div *ngIf="!handsetService.isXs" class="swiper-buttons-container">
      <div class="swiper-button-prev ml-10">
        <app-icon name="keyboard_arrow_left" color="#FFFFFF"></app-icon>
      </div>
      <div class="swiper-button-next mr-10">
        <app-icon name="keyboard_arrow_right" color="#FFFFFF"></app-icon>
      </div>
    </div>
    <div *ngIf="handsetService.isXs" class="swiper-buttons-container-xs">
      <div class="swiper-button-prev ml-20">
        <app-icon name="arrow_back"></app-icon>
      </div>
      <div class="flex">
        <span class="bold">{{ activeIndex + 1 }}</span> / {{ files.length }}
      </div>
      <div class="swiper-button-next mr-20">
        <app-icon name="arrow_forward"></app-icon>
      </div>
    </div>
  </div>
  <div *ngIf="base64Src">
    <ngx-extended-pdf-viewer  [base64Src]="base64Src"
                              [language]="'pl'"
                              [zoom]="'page-width'"
                              useBrowserLocale="true"
                              height="86vh">
    </ngx-extended-pdf-viewer>
  </div>
</div>
